import { ModalContext } from "context/ModalContext";
import { useProviderInitializedContext } from "hooks/useProviderInitializedContext";

export const useModalContext = () => {
  return useProviderInitializedContext(ModalContext);
};
